import React, { useState, Children, isValidElement, cloneElement } from 'react';
import ScrollableTabsStyled from './bundle.esm2.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ScrollableTabs = (props) => {
  const { className, children } = props;
  const { activeClassName: activeClassNameProp, defaultActiveItem } = props;
  const [activeItem, setActiveItem] = useState(defaultActiveItem != null ? defaultActiveItem : 0);
  const activeClassName = activeClassNameProp ? activeClassNameProp : "ScrollableTabs__item--active";
  return /* @__PURE__ */ React.createElement(ScrollableTabsStyled, {
    className: `ScrollableTabs ${className}`
  }, Children.map(children, (child, index) => {
    if (!isValidElement(child)) {
      return child;
    }
    const { props: props2 } = child;
    const { className: originalClassName } = props2;
    return cloneElement(child, __spreadProps(__spreadValues({}, props2), {
      onClick: () => {
        var _a;
        setActiveItem(index);
        (_a = props2 == null ? void 0 : props2.onClick) == null ? void 0 : _a.call(props2);
      },
      className: `ScrollableTabs__item ${originalClassName} ${activeItem === index ? activeClassName : ""}`
    }));
  }));
};
ScrollableTabs.defaultProps = {
  className: "",
  activeClassName: "",
  defaultActiveItem: 0
};

export { ScrollableTabs as default };
//# sourceMappingURL=bundle.esm.js.map
